import { useModalStore } from "@/stores/use-modal-store";
import { useEffect } from "react";

/* Prop Types */
interface UseModalErrorProps {
  error: boolean;
}

/*
 * useModalError custom hook
 * This hook is used to close a modal when an error occurs
 */
export const useModalError = ({ error }: UseModalErrorProps) => {
  /* Store */
  const { close } = useModalStore((state) => state.modalActions);

  /* Side Effects */
  useEffect(() => {
    if (error) close();
  }, [error, close]);

  return { close };
};
